import { get, post, upload } from '@/utils/request'

const SERVICE_URL = '/workflow-service/v1'

export function uploadProcessDefinition(params) {return upload(SERVICE_URL + '/process/upload', params)}
export function listProcessDefinitions(params) {return post(SERVICE_URL + '/process/listProcessDefinitions', params)}
export function getProcessDiagram(params) {return get(SERVICE_URL + '/process/getDiagramResourceBase64', params)}
export function getProcessDiagramCurrent(params) {return get(SERVICE_URL + '/process/getDiagramResourceBase64Current', params)}
export function fetchTaskNodesByDefId(params) {return get(SERVICE_URL + '/process/listAllTaskNodes', params)}
export function setUserTask(params) {return post(SERVICE_URL + '/process/setUserTask', params)}
export function countToDo(params) {return get(SERVICE_URL + '/process/countToDo', params)}
// 供应商端-待办
export function fetchTodoList(params) {return post(SERVICE_URL + '/process/listToDo', params)}
// 采购端-待办
export function listMyToDo(params) {return post(SERVICE_URL + '/process/listMyToDo', params)}

export function listAllStatus(params) {return get(SERVICE_URL + '/process/listAllStatus', params)}
// 审批历史---传一个工作流ID就行
export function listCommentHistory(params) {return get(SERVICE_URL + '/process/listCommentHistory', params)}

export function deleteDeployment(params) {return get(SERVICE_URL + '/process/deleteDeployment', params)}

export function listBindIds(params) {return get(SERVICE_URL + '/process/listBindIds', params)}